import React from "react";
import { Panel, Table } from "react-bootstrap";
import { formatDateTime } from "../../../utils";
import IconButton from "../../../components/common/IconButton";
import { connect } from "react-redux";
import { markNotificationAsRead } from "../../../actions/notificationsActions";
import HeaderWithButton from "./HeaderWithButton";

@connect(
    null,
    (dispatch, { notification }) => ({
        markedAsRead: _ => dispatch(markNotificationAsRead(notification._id))
    })
)
export default class NewEmployeeNotification extends React.Component {
    render() {
        let data = this.props.notification.data;
        return (
            <Panel>
                <HeaderWithButton notification={this.props.notification}>New employee created</HeaderWithButton>
                <Table>
                    <tbody>
                        <tr>
                            <th>Name</th>
                            <td>{data.name}</td>
                        </tr>
                        <tr>
                            <th>Date of birth</th>
                            <td>{data.dateOfBirth}</td>
                        </tr>
                        <tr>
                            <th>Added on</th>
                            <td>{formatDateTime(data.creationDate)}</td>
                        </tr>
                        <tr>
                            <th>Added by</th>
                            <td>{data.userDisplayName}</td>
                        </tr>
                        <tr>
                            <th>Location</th>
                            <td>{data.locationName}</td>
                        </tr>
                    </tbody>
                </Table>
            </Panel>
        );
    }
}
